import store from '@/state/store'
import { Helper } from '@/mixin/helper'

import { GET_CITIES } from '@/services/api/master/address'
import { GET_VEHICLE_TYPE } from '@/services/api/setting/fleet/fleetType'

const getFeatureFlagValue = store.getters['identity/getFeatureFlagValue']

let customFeature = {}

function hasCustomeFeatureMGM() {
  const data = getFeatureFlagValue('customFeature.mgm')
  customFeature.mgm = data
  return Array.isArray(data?.company_id) && data.company_id.includes(Helper.methods.getCompanyId())
}

let selectedCategory = null

async function fetchCities(opts) {
  const citiesResponse = await this.$apollo.query({
    query: GET_CITIES,
    fetchPolicy: 'no-cache',
    variables: {
      filter: {
        pagination: {
          page: opts?.page,
          show: opts?.limit || 5,
        },
        search: opts?.search || undefined,
      },
    },
  })

  const citiesData = citiesResponse.data.data.cities.data

  return {
    metadata: {
      total_count: citiesResponse.data.data.cities.pagination.total,
      page: citiesResponse.data.data.cities.pagination.page,
    },
    data: {
      paginated_result: citiesData,
    },
  }
}

async function fetchVehicleCategory(opts) {
  if (opts?.page === 1) {
    selectedCategory = null
  }
  if (hasCustomeFeatureMGM()) {
    return {
      metadata: {
        total_page: 1,
        total_count: 0,
        page: 1,
      },
      data: {
        paginated_result: customFeature.mgm?.filtered_vehicle_category
          .map((category) => ({ category }))
          .filter((item) => {
            if (!opts.search) return true
            return item.category?.toLowerCase().includes(opts.search.toLowerCase())
          }),
      },
    }
  }
}

async function fetchVehicleType(opts) {
  const rowItem = opts?.rowItem || {}

  const category = selectedCategory || rowItem.vehicle_category_name

  if (!category) {
    return {
      metadata: {
        total_count: 0,
        page: 1,
      },
      data: {
        paginated_result: [],
      },
    }
  }

  const filter = {
    pagination: {
      page: opts?.page,
      show: opts?.limit,
    },
    search: opts?.search,
    category: typeof category === 'object' ? category.category : category,
  }
  const res = await this.$apollo.query({
    query: GET_VEHICLE_TYPE,
    fetchPolicy: 'no-cache',
    variables: {
      filter: {
        ...filter,
      },
    },
  })

  const result = res.data.vehicleTypes.vehicleTypes

  return {
    metadata: {
      total_count: result.pagination.total,
      page: result.pagination.page,
    },
    data: {
      paginated_result: result.data,
    },
  }
}

const bufferTimeFields = [
  {
    editable: true,
    name: 'origin_city',
    label: 'setting.bufferTime.fields.originCity',
    placeholder: 'setting.bufferTime.fields.originCity',
    key: 'origin_city',
    type: 'select-resourceful',
    trackBy: 'name',
    validation: 'required',
    optionsGetter: fetchCities,
    optionLabelFn: ({ item }) => item.name,
    getInitialObject: (obj) => {
      return { name: obj?.origin_city }
    },
    thAttr: {
      style: 'min-width:180px;',
    },
  },
  {
    editable: true,
    name: 'destination_city',
    label: 'setting.bufferTime.fields.destinationCity',
    placeholder: 'setting.bufferTime.fields.destinationCity',
    key: 'destination_city',
    type: 'select-resourceful',
    trackBy: 'name',
    validation: 'required',
    optionsGetter: fetchCities,
    optionLabelFn: ({ item }) => item.name,
    getInitialObject: (obj) => {
      return { name: obj?.destination_city }
    },
    thAttr: {
      style: 'min-width:180px;',
    },
  },
  {
    editable: true,
    name: 'vehicle_category_name',
    label: 'setting.bufferTime.fields.vehicleCategory',
    placeholder: 'setting.bufferTime.fields.vehicleCategory',
    key: 'vehicle_category_name',
    type: 'select-resourceful',
    trackBy: 'category',
    validation: 'required',
    optionsGetter: fetchVehicleCategory,
    optionLabelFn: ({ item }) => item.category,
    getInitialObject: (obj) => {
      return { category: obj?.vehicle_category_name }
    },
    handleChange: (item) => {
      selectedCategory = item
    },
    thAttr: {
      style: 'min-width:180px;',
    },
  },
  {
    editable: true,
    name: 'vehicle_type_id',
    label: 'setting.bufferTime.fields.vehicleType',
    placeholder: 'setting.bufferTime.fields.vehicleType',
    key: 'vehicle_type_id',
    type: 'select-resourceful-v2',
    trackBy: 'vehicleTypeId',
    formatter: (value, key, item) => {
      return item?.vehicle_type?.name ?? '-'
    },
    optionsGetter: fetchVehicleType,
    optionLabelFn: ({ item }) => `${item.manufacturer} - ${item.model} - ${item.type}`,
    selectedLabel: 'type',
    customValueFn: (item) => item?.vehicle_type_id ?? item?.vehicle_type?.id ?? false,
    getInitialObject: (obj) => {
      const vehicleType = obj?.vehicle_type
      if (!vehicleType) return null

      return {
        vehicleTypeId: vehicleType.id,
        type: vehicleType.name,
      }
    },
    thAttr: {
      style: 'min-width:180px;',
    },
  },
  {
    editable: true,
    name: 'duration',
    label: 'setting.bufferTime.fields.bufferTime',
    placeholder: 'setting.bufferTime.fields.bufferTime',
    key: 'duration',
    type: 'hour-minute',
    validation: 'required|isoTimeGteValue:PT1M',
    customColumn: true,
    thAttr: {
      style: 'min-width:180px;',
    },
  },
]

export default bufferTimeFields
